import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import {
  setDefaultRelativeTimeControlValue,
  TIME_DIRECTION_SELECT_OPTIONS,
  TIME_UNIT_SELECT_OPTIONS,
} from './form-relative-time-input.constants';
import { RelativeTimeForm } from './form-relative-time-input.types';

@Component({
  selector: 'mg-form-relative-time-input',
  templateUrl: './form-relative-time-input.component.html',
  styleUrls: ['./form-relative-time-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormRelativeTimeInputComponent {
  // Constants

  public readonly TIME_DIRECTION_OPTIONS = TIME_DIRECTION_SELECT_OPTIONS;
  public readonly TIME_UNIT_OPTIONS = TIME_UNIT_SELECT_OPTIONS;

  // Inputs

  @Input() label: string;
  @Input() tooltip: string;
  @Input() set control(formGroup: FormGroup<RelativeTimeForm>) {
    this.form = formGroup;
  }

  // Form Group

  public form: FormGroup<RelativeTimeForm> = setDefaultRelativeTimeControlValue();

  // Component Constructor

  constructor() {}
}
